export default {
  SalaryScaleCodeTitle: 'Mã ngạch lương',
  SalaryScaleCode: 'Mã ngạch lương *',
  SalaryScaleName: 'Tên ngạch lương',
};
